import React, { createContext, useContext } from 'react';

export const PreviewSlideoutContext = createContext<(() => void) | null>(null);

export const usePreviewSlideoutContext = () => useContext(PreviewSlideoutContext);
